import { Typography } from "antd";
import type { PropsWithChildren } from "react";

import { monoFontFamily } from "@/theme/index";

/** 表格内 `placement_key` / `node_id` 等等宽字体列 */
export function MonospaceCell({
  children,
  title,
}: PropsWithChildren<{ title?: string }>) {
  return (
    <Typography.Text
      code
      ellipsis={{ tooltip: title ?? children }}
      style={{
        fontFamily: monoFontFamily,
        margin: 0,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </Typography.Text>
  );
}
